import { DataCollection, ScreenInfo } from '../jarvis/dataCollection';

type MediaclipAnalyticsKey = string;
type MediaclipAnalyticsValue = string | number;

export class MediaclipEvents {
  static sendScreenViewEvent(dataCollection: DataCollection) {
    dataCollection.sendScreenViewEvent(this.screenInfo);
  }

  static sendAppMetricsData(
    events: Record<MediaclipAnalyticsKey, MediaclipAnalyticsValue>,
    dataCollection: DataCollection,
  ) {
    this.supportedAppMetrics.forEach((key) => {
      const value: MediaclipAnalyticsKey = events[key]?.toString();
      if (value) {
        dataCollection.sendControlClickedEvent(
          { name: this.titleCase(key), detail: value.toString() },
          MediaclipEvents.screenInfo,
        );
      }
    });
  }

  static sendDesignerHookData(key: MediaclipAnalyticsKey, dataCollection: DataCollection) {
    if (this.supportedDesignerHooks.includes(key)) {
      dataCollection.sendControlClickedEvent(this.titleCase(key), MediaclipEvents.screenInfo);
    } else {
      console.error(`MediaclipEvents::sendDesignerHookData: '${key}' is not a supported hook`);
    }
  }

  // Private

  private static screenInfo: ScreenInfo = {
    name: 'Designer',
    activity: 'CreatePhotobook-v01',
  };

  private static titleCase(value: string) {
    let allowUpperCase = false;
    let forceUpperCase = true;
    let result = '';
    for (let idx = 0; idx < value.length; idx++) {
      const char = value.charAt(idx);
      const isUpperCase = char.match(/[A-Z]/);
      const isLetter = char.match(/[a-zA-Z]/);
      if (forceUpperCase) {
        result += char.toUpperCase();
        allowUpperCase = false;
        forceUpperCase = false;
      } else if (isUpperCase && allowUpperCase) {
        result += char;
        allowUpperCase = false;
        forceUpperCase = false;
      } else if (isLetter) {
        result += char.toLowerCase();
        allowUpperCase = !isUpperCase;
        forceUpperCase = false;
      } else {
        allowUpperCase = true;
        forceUpperCase = true;
      }
    }
    return result;
  }

  // The following supported values are defined in the analytics specification located here:
  // https://docs.google.com/spreadsheets/d/13IX8DBUuqSn9OseGromPNlngjXz06LqK56oAGwfp3i4/edit#gid=0

  private static supportedAppMetrics: Array<MediaclipAnalyticsKey> = [
    'btn_event_toggle',
    'btn_photo_toggle',
    'btn_filter_toggle',
    'btn_border_toggle',
    'btn_text_toggle',
    'btn_layout_toggle',
    'btn_style_toggle',
    'btn_background_toggle',
    'btn_clipart_toggle',
    'bgEl_changedPhoto',
    'preview',
    'edit',
    'help',
    'save',
    'addToCart',
    'pageTrack_toggle',
    'pageTrack_opened',
    'pageTrack_closed',
    'change_orientation',
    'change_theme',
    'sidePanel_opened',
    'sidePanel_closed',
    'photoEl_applied',
    'photoEl_changed',
    'photoEl_createdWPhoto',
    'photoEl_createdEmpty',
    'photoEl_swapped',
    'bgEl_changedPhoto',
  ];

  private static supportedDesignerHooks: Array<MediaclipAnalyticsKey> = [
    'onBeforeAutofill',
    'onBeforeUpload',
    'onUploadComplete',
    'onUploadPhotos',
  ];
}
